import React from 'react'
import {Context as AppContext} from '../../contexts/App'
import ObjectForm from '../../components/ObjectForm'
import InventoryProducts from './products'
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
const InventoryCreate = ({open, close, model, ...rest}) => {
    const app = React.useContext(AppContext)
    const { recall, setRecall } = app
    const { warehouses, } = app.warehouses
    const { create, update, } = app.inventories
    const { allProducts } = app.products
    
    const submit = model?update:create
    const title = model?"Actualizar":"Añadir"

    return (
        <Dialog onClose={close} open={open}>
            <DialogTitle>{title} Inventario</DialogTitle>
            <ObjectForm ignored={['id']} recall={recall} submit={submit}
                obj={{warehouse:'', sku:'', quantity:'', name:'', description:'', products: ''}}
                labels={{warehouse: 'almacén', sku:'sku', quantity:'cantidad inicial', name:'nombre', description:'descripción', products: 'productos' }}
                types={{warehouse:'select', sku:'text', quantity:'number', name:'text', description:'text', products: 'custom' }}
                options={{warehouse: warehouses.map((w) => ({value:w.id, label:w.name})) }}
                custom={{products: InventoryProducts}}
                customData={{ products: allProducts }}
                changed={model|| {}} 
            />
            <Button onClick={() => {setRecall(true);close()}}>{title}</Button>
        </Dialog>
    )
}
export default InventoryCreate